import styled from 'styled-components'

export const Container = styled.div`
    min-height: calc(
            100vh - ${(props) => {return props.theme.headerHeight}}px
                - ${(props) => {return props.theme.footerHeight}}px
        );
    color: ${(props) => {return props.theme.colorPrimary}};
    display: flex;
    flex-direction: column;

    > div {
        display: flex;
        flex-direction: column;
        padding: 30px 10px 0;
        height: 1fr;
        width: 1100px;
        max-width: 100%;
        margin: 0 auto;
    }

    .hidden {
        display: none;
    }

    .header {
        height: 40px;
        text-align: center;
        font-size: 1.6rem;
        font-weight: bolder;
        color: ${(props) => {return props.theme.colorPrimary}};
    }

    .section1 {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .pitch {
            width: 65%;
            border-radius: 10px;
            margin: 0 5px 5px 0;
            overflow: hidden;
            position: relative;
            height: calc(.36 * 1100px);
            box-shadow: ${(props) => {return props.theme.shadow}};

            .empty-video {
                height: 100%;
                align-items: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                color: #ddd;
            }

            & iframe {
                left: 0;
                top: 0;
                height: 100%;
                width: 100%;
                position: absolute;
            }

            @media screen and (max-width: 900px) {
                width: 100%;
                margin: 0 0 5px 0;
                height: 55vw;
            }
        }

        .sidebar {
            display: flex;
            flex-direction: column;
            width: 34%;
            margin-bottom: 5px;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: ${(props) => {return props.theme.shadow}};

            .logo1 {
                overflow: hidden;
                border-radius: 8px;
                height: 150px;
                display: flex;
                align-items: center;

                img {
                    width: 100%;
                    border-radius: 8px;
                }
            }

            .sidebar-content {
                padding: 5px 20px;

                > span {
                    font-size: .8rem;
                    color: #666;
                }

                hr {
                    margin: 5px 0;
                }

                .sidebar-item {
                    padding: 5px 0;
                }
            }

            @media screen and (max-width: 900px) {
                width: 100%;
                padding: 5px;

                .logo1 {
                    height: 100%;

                    img {
                        height: 100%;
                        border-radius: 8px;
                        object-fit: cover;
                    }
                }
            }
        }
    }

    .section2 {
        padding: 10px;
        border-radius: 10px;
        margin: 10px 0 20px;
        box-shadow: ${(props) => {return props.theme.shadow}};

        .content-box {
            padding: 10px 10px 0;
            overflow: hidden;

            span {
                display: inline-block;
                margin: 5px 0;
                color: #666;
            }

            p {
                text-align: justify;
            }

            .adicional-box {
                display: flex;

                p {
                    text-align: start;
                }

                div:nth-child(1) {
                    margin-right: 100px;
                }

                @media screen and (max-width: 900px) {
                    div:nth-child(1) {
                        margin-right: 50px;
                    }
                }
            }
        }
    }
`
